export abstract class Serializable<T>{
	abstract toApi():T;
	constructor(protected source:T){
	}
}


// WEBPACK FOOTER //
// ./src/util/domain/serializable.ts